import { IconWrapper } from '@flexo/general';
import { ALERT, alertCallbackStore, API_KEYS } from '@flexo/reducers';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Button from '../../button/button';
import styles from './../alert.module.scss';

export default function AlertRevokeApiKey() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const content = t('alerts.revoke_api_key', { returnObjects: true }) as any;

  async function onConfirm() {
    const data = alertCallbackStore.getData();

    if (data.keyName) {
      try {
        await dispatch(API_KEYS.RevokeApiKeyAsync(data.keyName) as any);
        alertCallbackStore.clearAll();
        dispatch(ALERT.ResetAlert({} as any));
      } catch (error) {
        console.error('AlertRevokeApiKey: error revoking key:', error);
        alertCallbackStore.clearAll();
      }
    } else {
      alertCallbackStore.clearAll();
      dispatch(ALERT.ResetAlert({} as any));
    }
  }

  function onCancel() {
    alertCallbackStore.clearAll();
    dispatch(ALERT.ResetAlert({} as any));
  }

  return (
    <div>
      <div
        id="alert-revoke-api-key"
        className={`${styles.Alert} ${styles.Alert__Confirm__Credentials__Changes}`}
      >
        <div className={styles.Alert__Title__Negative}>
          <div>
            <IconWrapper iconName="alert" />
            {content.title}
          </div>
          <div className={styles.Alert__Title__Close}></div>
        </div>

        <div className={styles.Alert__Content}>{content.description}</div>

        <div className={`${styles.Alert__Footer__Actions} mt-2`}>
          <Button
            variant="secondary"
            color="grey"
            className={`${styles.Alert__Footer__Actions__Button} ${styles.Alert__Footer__Actions__Button__Cancel}`}
            label={content.cancel}
            onClick={onCancel}
          />
          <Button
            className={`${styles.Alert__Footer__Actions__Button} ${styles.Alert__Footer__Actions__Button__Confirm}`}
            variant="primary"
            color="negative"
            label={content.confirm}
            onClick={onConfirm}
          />
        </div>
      </div>
    </div>
  );
}
